import axios from "axios";
import { api } from "./api_route";
import { resetDataAndLogout } from "../helpers/auth";

export const getUsers = async () => {
  try {
    const result = await axios.get(`${api}/users/`);

    return result.data;
  } catch (error) {
    return [];
  }
};

export const createUser = async (values) => {
  try {
    const result = await axios.post(`${api}/users/create`, { values });

    const { data, status, statusText } = result;
    return { data, status, statusText };
  } catch (error) {
    return [];
  }
};

export const updateUser = async (values) => {
  try {
    const result = await axios.post(`${api}/users/update`, { values });

    return result.data;
  } catch (error) {
    return [];
  }
};

export const changePassword = async (values) => {
  try {
    const result = await axios.post(`${api}/users/changePassword`, { values });

    return result.data;
  } catch (error) {
    return [];
  }
};

export const resetPassword = async (values) => {
  try {
    const result = await axios.post(`${api}/users/resetPassword`, { values });

    return result.data;
  } catch (error) {
    return [];
  }
};

export const userResetPasswordAccess = async (values) => {
  try {
    const result = await axios.get(`${api}/users/userResetPassword`);

    return result.data;
  } catch (error) {
    return [];
  }
};

export const isActiveUser = async (values) => {
  try {
    const result = await axios.post(`${api}/users/updateIsActive`, { values });
    return result.data;
  } catch (error) {
    return [];
  }
};

export const deleteUsers = async (values) => {
  try {
    const result = await axios.post(`${api}/users/deleteUsers`, { values });

    if (result) {
    } else if (!result) {
    }
    return result.data;
  } catch (error) {
    return [];
  }
};

export const login = async (values) => {
  try {
    const result = await axios.post(`${api}/users/login`, {
      values,
    });

    return result.data;
  } catch (error) {
    return [];
  }
};

export const forgotPassword = async (values) => {
  try {
    const result = await axios.post(`${api}/login/forgotpassword`, {
      values,
    });

    return result.data;
  } catch (error) {
    return [];
  }
};

export const forgotPasswordOTPValidation = async (values) => {
  try {
    const result = await axios.post(
      `${api}/login/forgotpasswordotpvalidation`,
      {
        values,
      }
    );

    return result;
  } catch (error) {
    return [];
  }
};

export const createUserForm = async () => {
  try {
    const role = await axios.get(`${api}/userRole`);
    const designation = await axios.get(`${api}/userDesignation`);
    const test = await axios.get(
      `${api}/organizationBranch/organizationRegionData`
    );

    const roles = role?.data?.data;
    const designations = designation?.data?.data;
    const region = test?.data?.data;
    return { roles, designations, region };
  } catch (error) {
    return [];
  }
};

export const getUserInformation = async (values) => {
  try {
    const result = await axios.get(`${api}/users/getUserInformation`);

    return result.data;
  } catch (error) {
    return [];
  }
};

export const getLoginUser = async () => {
  try {
    const result = await axios.get(`${api}/users/getLoginUser`);

    return result.data;
  } catch (error) {
    resetDataAndLogout();

    return [];
  }
};

export const allVishlawGlobalOrganisationUser = async (values) => {
  try {
    const result = await axios.post(
      `${api}/caseDetails/allVishlawGlobalOrganisationUser`,
      values
    );

    return result;
  } catch (error) {
    return [];
  }
};

export const checkUsernameUnique = async (values) => {
  try {
    const result = await axios.post(`${api}/users/check-unique`, values);

    return result.data;
  } catch (error) {
    return [];
  }
};

export const uploadProfileImage = async (formData) => {
  try {
    const result = await axios.post(`${api}/users/uploadProfileImage`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return result.data;
  } catch (error) {
    console.error("Upload error:", error);
    return { error: error.message };
  }
};

export const deleteProfileImage = async (data) => {
  try {
    const result = await axios.post(`${api}/users/deleteProfileImage`, data);
    return result.data;
  } catch (error) {
    console.error("Delete error:", error);
    return { error: error.message };
  }
};

export const updateUserProfile = async (values) => {
  try {
    const result = await axios.post(`${api}/users/updateProfile`, { values });
    return result.data;
  } catch (error) {
    console.error("Update profile error:", error);
    return { error: error.message };
  }
};
